<template>
  <div id="app">
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-sm-8 offset-sm-2">
          <div id="brand" class="m-3">
            <a :href="brand.url || '#'" :title="brand.title">
              <img
                class="img-fluid"
                v-if="brand.logoUrl"
                :src="brand.logoUrl"
                :alt="brand.title || 'Online Receipts'"
              />
              <h1 v-else-if="brand.title" class="m-0">{{ brand.title }}</h1>
            </a>
            <p v-if="brand.text" class="text-muted m-3">{{ brand.text }}</p>
          </div>
        </div>
      </div>
    </div>
    <router-view />
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-sm-8 offset-sm-2">
          <div id="brand-footer" class="m-3" v-if="brand.footer">
            <a :href="brand.footer.url || '#'" :title="brand.footer.title">
              <img
                class="img-fluid"
                v-if="brand.footer.imageUrl"
                :src="brand.footer.imageUrl"
                :alt="brand.footer.title"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  background-color: #f1f1f1;
}
</style>

<script>
export default {
  name: "app",
  computed: {
    brand: function() {
      const host = window.location.hostname;

      // default branding
      const brand = {
        logoUrl: "/img/default-logo.png",
        title: "Online Receipts",
        text: "For transaction enquiries, please call 0203 9555 400",
        url: "https://ccs.im"
      };

      if (host.indexOf("cabcard.services") !== -1) {
        // set the branding for CCS
        brand.logoUrl = "/img/ccsuk-logo.png";
        brand.title = "CabCard Services Receipts";
        brand.text = "Transactions processed by CabCard Services";
        brand.url = "https://cabcard.services";
      } else if (host.indexOf("optimuspay.co.uk") !== -1) {
        // set the branding for Optimus Pay
        brand.logoUrl = "/img/optimus-logo.png";
        brand.title = "Optimus Pay Receipts";
        brand.text = "Transactions processed by Optimus Pay";
        brand.url = "https://optimuspay.co.uk";
      } else if (host.indexOf("torbay") !== -1) {
        // set the branding for Torbay Taxi fleet
        brand.logoUrl = "/img/torbay-taxis-logo.png";
        brand.title = "Torbay Taxis Receipts";
        brand.text =
          "Call 01803 211 611 to book now.\nTransactions processed by CabCard Services";
        brand.url = "https://torbaytaxis.co.uk";
      } else if (host.indexOf("avenue") !== -1) {
        // set the branding for Avenue Taxi fleet
        brand.logoUrl = "/img/avenue-taxis-logo.png";
        brand.title = "Avenue Taxis Receipts";
        brand.text =
          "Call 01473 888 888 to book now.\nTransactions processed by CabCard Services";
        brand.url = "https://www.avenue-taxis.co.uk";
      } else if (host.indexOf("wheels") !== -1) {
        // set the branding for Wheels Taxi fleet
        brand.logoUrl = "/img/wheels-private-hire-logo.png";
        brand.title = "Wheels Private Hire Receipts";
        brand.text =
          "Call 0113 249 9999 to book now.\nTransactions processed by CabCard Services";
        brand.url = "https://www.wheelsprivatehireleeds.com";
      } else if (host.indexOf("toa") !== -1) {
        // set the branding for TOA Birmingham
        brand.logoUrl = "/img/toa-taxis-logo.png";
        brand.title = "TOA Taxis Receipts";
        brand.text =
          "Call 0121 427 8888 to book now.\nTransactions processed by CabCard Services";
        brand.url = "https://www.toataxis.co.uk";
        brand.footer = {
          title: "Download TOA Taxis app",
          url: "https://toataxis.co.uk",
          imageUrl: "/img/toa-taxis-footer.png"
        };
      } else if (host.indexOf("gatwick") !== -1) {
        // set the branding for Airport Cars Gatwick
        brand.logoUrl = "/img/airport-cars-gatwick-logo.png";
        brand.title = "Airport Cars Gatwick Receipts";
        brand.text =
          "Gatwick Cars Ltd is acting as a disclosed agent for the driver, resulting in all our customers entering into a direct contract with the driver.\nFor any queries please contact bookings@airportcars-gatwick.com.\nTransactions processed by CabCard Services";
        brand.url = "https://www.airportcars-gatwick.com";
      }

      return brand;
    }
  }
};
</script>
